import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ChickenNoodle from '~/assets/chicken_noodle.jpg';
import SignUpForm from '~/components/account/SignUpForm.jsx';
import AppToolBar from '~/components/AppToolBar';
import ImageBox from '~/components/ImageBox.jsx';
import Page from '~/components/Page.jsx';
import { selectIsUserLoggedIn } from '~/store/legacy/selector/userSelectors.js';

const useStyles = makeStyles((theme) => ({
  headline: {
    margin: '40px 0',
  },
  container: {
    [theme.breakpoints.up('lg')]: {
      maxWidth: 1024,
    },
  },
  signUpShowPhoto: {
    height: '100%',
  },
  formContainer: {
    [theme.breakpoints.down('xs')]: {},
    padding: '20px 0',
  },
}));

function SignUp() {
  const classes = useStyles();
  const router = useRouter();
  const isUserLoggedIn = useSelector(selectIsUserLoggedIn);

  useEffect(() => {
    if (isUserLoggedIn) {
      if (router.query.redirect) {
        router.replace(router.query.redirect);
      } else {
        router.replace('/');
      }
    }
  }, [isUserLoggedIn]);

  return (
    <Page name='sign-up'>
      <AppToolBar />
      <Grid container style={{ paddingBottom: '4rem' }}>
        <Grid container justify='center' className={classes.headline}>
          <Typography align='center' variant='h5'>
            Start Eating Authentically
          </Typography>
        </Grid>
        <Grid container justify='center'>
          <Grid item xs={12} md={8} lg={7} className={classes.container}>
            <Paper elevation={1}>
              <Grid container>
                <Hidden xsDown>
                  <Grid item sm={4} style={{ maxHeight: '100%' }}>
                    <ImageBox fit='cover' src={ChickenNoodle} />
                  </Grid>
                </Hidden>
                <Grid
                  container
                  justify='center'
                  className={classes.formContainer}
                  item
                  xs={12}
                  sm={8}>
                  <Grid item sm={9} xs={10}>
                    <SignUpForm />
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </Page>
  );
}

export default SignUp;
